/**
 * @generated SignedSource<<727ff66c40ceee032783e55e521d03bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdDetailsModal_PerformanceSummarizedMetaAd$data = {
  readonly aggregatedLabels: ReadonlyArray<string> | null;
  readonly amountSpent: any | null;
  readonly costPerPurchase: number | null;
  readonly costPerPurchasePercentile: number | null;
  readonly costPerWebsitePurchase: number | null;
  readonly costPerWebsitePurchasePercentile: number | null;
  readonly id: string;
  readonly landingPageViews: any | null;
  readonly landingPageViewsPercentile: number | null;
  readonly name: string | null;
  readonly purchases: number | null;
  readonly purchasesPercentile: number | null;
  readonly tags: ReadonlyArray<string> | null;
  readonly websiteAddToCarts: any | null;
  readonly websiteAddToCartsPercentile: number | null;
  readonly websitePurchases: any | null;
  readonly websitePurchasesPercentile: number | null;
  readonly " $fragmentType": "AdDetailsModal_PerformanceSummarizedMetaAd";
};
export type AdDetailsModal_PerformanceSummarizedMetaAd$key = {
  readonly " $data"?: AdDetailsModal_PerformanceSummarizedMetaAd$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdDetailsModal_PerformanceSummarizedMetaAd">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdDetailsModal_PerformanceSummarizedMetaAd",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountSpent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "websitePurchases",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "websiteAddToCarts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingPageViews",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "costPerPurchase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "costPerWebsitePurchase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "websitePurchasesPercentile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "websiteAddToCartsPercentile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "costPerPurchasePercentile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "costPerWebsitePurchasePercentile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purchases",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purchasesPercentile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingPageViewsPercentile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aggregatedLabels",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    }
  ],
  "type": "PerformanceSummarizedMetaAd",
  "abstractKey": null
};

(node as any).hash = "1f248ab4c2375802b4deb491c56f43b9";

export default node;
